<template>
  <AuthenticatedLayout>
    <ProdutosTable />
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import ProdutosTable from "@/views/components/ProdutosTable.vue";

export default {
  name: "Produtos",
  components: {
    AuthenticatedLayout,
    ProdutosTable,
  },
};
</script>
